import { useRef } from 'react'

/**
 * Горизонтальный скролл таблицы протяжкой мыши с зажатой левой кнопкой.
 * Нажатия на интерактивных элементах (инпут, ссылка, кнопка, дропдаун) не перехватываем,
 * а клик после протяжки гасим — иначе drag заканчивался бы переходом по ссылке под курсором.
 */
const INTERACTIVE_SELECTOR = 'input, textarea, select, button, a, label, [role="button"], .dropdown'
const DRAG_THRESHOLD = 5

function useTableDragScroll() {
	const scrollRef = useRef(null)
	const dragStateRef = useRef({
		isMouseDown: false,
		startX: 0,
		startScrollLeft: 0,
		hasDragged: false,
	})

	function handleMouseDown(e) {
		if (!scrollRef.current) return
		if (e.button !== 0) return
		if (e.target?.closest?.(INTERACTIVE_SELECTOR)) return

		dragStateRef.current.isMouseDown = true
		dragStateRef.current.startX = e.pageX
		dragStateRef.current.startScrollLeft = scrollRef.current.scrollLeft
		dragStateRef.current.hasDragged = false
	}

	function handleMouseMove(e) {
		if (!dragStateRef.current.isMouseDown || !scrollRef.current) return
		const deltaX = e.pageX - dragStateRef.current.startX

		if (!dragStateRef.current.hasDragged && Math.abs(deltaX) > DRAG_THRESHOLD) {
			dragStateRef.current.hasDragged = true
			// уже начатое выделение снимаем, дальнейшее глушим классом
			window.getSelection()?.removeAllRanges()
			scrollRef.current.classList.add('table-drag-active')
		}

		if (dragStateRef.current.hasDragged) {
			e.preventDefault()
			scrollRef.current.scrollLeft = dragStateRef.current.startScrollLeft - deltaX
		}
	}

	function handleMouseUp() {
		dragStateRef.current.isMouseDown = false
		scrollRef.current?.classList.remove('table-drag-active')
	}

	function handleClickCapture(e) {
		if (dragStateRef.current.hasDragged) {
			e.preventDefault()
			e.stopPropagation()
			dragStateRef.current.hasDragged = false
		}
	}

	return {
		ref: scrollRef,
		onMouseDown: handleMouseDown,
		onMouseMove: handleMouseMove,
		onMouseUp: handleMouseUp,
		onMouseLeave: handleMouseUp,
		onClickCapture: handleClickCapture,
	}
}

export default useTableDragScroll
